/*eslint-disable*/
import format from "timestamp-format";
function toName(name) {
  return new Array(name.length).join("*") + name.substr(-1);
}
function moneyFilter(cost) {
  var money = Number(cost).toFixed(2).split(".");
  money[0] = money[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return money.join(".");
}
// 奖池用户姓名
function jackpotUserName(name) {
  name = name.toString();
  return name.slice(0, 3) + "***" + name.slice(-2);
  // return name.slice(0,3) + new Array(name.length-4).join('*') + name.slice(-2);
}

function formatPhone(phone) {
  phone = phone + "";
  return phone.substr(0, 3) + " **** " + phone.substr(7, 11);
}
function formatPhone2(phone) {
  phone = phone + "";
  return phone.substr(0, 4) + " *** " + phone.substr(7, 11);
}
function bankNumber(num) {
  num = num + "";
  if (num.length === 19) {
    return " **** **** **** **** " + num.substr(16, 19);
  } else if (num.length === 16) {
    return " **** **** **** " + num.substr(12, 16);
  } else if (num.length === 17) {
    return " **** **** **** " + num.substr(12, 17);
  }
}
function DCbankNumber(num) {
  return " **** **** **** ****" + num.substr(num.length - 4, num.length);
}
// 货币类型
function DCUsdtType(type) {
  let S = "";
  switch (type) {
    case "0":
      return "TRC20";
    case "1":
      return "ERC20";
    case "2":
      return "HECO";
    case "3":
      return "OMNI";
  }
  return S;
}
function gameType(val) {
  if (val === "1") {
    return "老虎机";
  } else if (val === "2") {
    return "真人";
  } else if (val === "3") {
    return "体育";
  } else if (val === "4") {
    return "彩票";
  } else if (val === "5") {
    return "捕鱼";
  } else if (val === "6") {
    return "棋牌";
  } else if (val === "7") {
    return "其他";
  }
}
function gameType2(val) {
  if (val === "1") {
    return "电子";
  } else if (val === "2") {
    return "真人";
  } else if (val === "3") {
    return "体育";
  } else if (val === "4") {
    return "彩票";
  } else if (val === "5") {
    return "捕鱼";
  } else if (val === "6") {
    return "棋牌";
  } else if (val === "7") {
    return "3D厅";
  }
}
//电子游戏类型
function slotgameType(val) {
  if (val) {
    if (val == "1") {
      return "累积奖池";
    } else if (val == "2") {
      return "经典老虎机";
    } else if (val == "3") {
      return "消消乐";
    } else if (val == "4") {
      return "电动吃角子";
    } else if (val.length > 1) {
      let str = val.substring(0, 1);
      if (str == "1") {
        return "累积奖池";
      } else if (str == "2") {
        return "经典老虎机";
      } else if (str == "3") {
        return "消消乐";
      } else if (str == "4") {
        return "电动吃角子";
      }
    }
  }
}
//电子游戏线型
// function slotgameType(val) {
//   if(val==='1'){
//     return '累积奖池'
//   }else if(val==='2'){
//     return '经典老虎机'
//   }else if(val==='3'){
//     return '消消乐'
//   }else if(val==='4'){
//     return '电动吃角子'
//   }
// }
function changeName(val) {
  // filterType:状态 -1=全部 0:申请中，1:进行中，2:成功发放，3:拒绝，4:失败，5未领取，6未抽中
  // filterType:状态 -1=全部 0:申请中，1:成功领取，2:完成流水，3:拒绝，4:清除稽核，5未领取，6未抽中
  if (val === "0") {
    return "申请中";
  } else if (val === "1") {
    return "成功领取";
  } else if (val === "2") {
    return "完成流水";
  } else if (val === "3") {
    return "拒绝";
  } else if (val === "4") {
    return "清除稽核";
  } else if (val === "5") {
    return "未领取";
  } else if (val === "6") {
    return "未抽中";
  }
}
function changeTitle(val) {
  if (val === "0") {
    return "申请中";
  } else if (val === "1") {
    return "系统调帐";
  } else if (val === "2") {
    return "充值存款";
  } else if (val === "3") {
    return "秒速取款";
  } else if (val === "4") {
    return "转入游戏";
  } else if (val === "5") {
    return "游戏转出";
  } else if (val === "8") {
    return "优惠红利";
  } else if (val === "9") {
    return "人工存入";
  } else if (val === "10") {
    return "人工取出";
  }
}
function subChangeTitle(val) {
  if (val === "0") {
    return "申";
  } else if (val === "1") {
    return "系";
  } else if (val === "2") {
    return "充";
  } else if (val === "3") {
    return "秒";
  } else if (val === "4") {
    return "转";
  } else if (val === "5") {
    return "游";
  } else if (val === "8") {
    return "优";
  }
}
// 红利类型
function bonusName(type) {
  let type1 = "";
  switch (type) {
    case "1":
      type1 = "流水返利";
      return type1;
    case "2":
      type1 = "存款优惠";
      return type1;
    case "3":
      type1 = "邀请奖励";
      return type1;
    case "4":
      type1 = "签到奖励";
      return type1;
    case "6":
      type1 = "连续存款优惠";
      return type1;
    case "7":
      type1 = "注册优惠";
      return type1;
    case "A":
      type1 = "救援金";
      return type1;
    case "B":
      type1 = "VIP升级奖励";
      return type1;
    case "C":
      type1 = "VIP蝉联奖励";
      return type1;
    default:
      type1 = "其他优惠";
      return type1;
  }
}
// 红利锁定状态
function bonusLockStatus(status) {
  let type1 = "";
  switch (status) {
    case "1":
      type1 = "锁定中";
      return type1;
    case "2":
      type1 = "已解锁";
      return type1;
    case "4":
      type1 = "已取消";
      return type1;

    default:
      type1 = "锁定中";
      return type1;
  }
}
// 红利锁定平台
function bonusLockPlatform(platform) {
  let type1 = "";
  switch (platform) {
    case "-1":
      type1 = "主账户";
      return type1;
    default:
      type1 = platform;
      return type1;
  }
}
// 存款锁定状态
function depositLockStatus(status) {
  let type1 = "";
  switch (status) {
    case "0":
      type1 = "锁定中";
      return type1;
    case "1":
      type1 = "已解锁";
      return type1;
    default:
      type1 = "锁定中";
      return type1;
  }
}

function userName(name) {
  name = name.toString();
  return name.slice(0, 3) + "***" + name.slice(-2);
  // return name.slice(0,3) + new Array(name.length-4).join('*') + name.slice(-2);
}
function getTimeMS(time) {
  return format("yyyy-MM-dd hh:mm:ss", time);
}
function getTimeMS_(time) {
  return format("dd-MM-yyyy hh:mm", time);
}
function getTimeCM(time) {
  return format("yyyy年MM月dd日 hh:mm:ss", time);
}
function getTimeMD(time) {
  return format("yyyy-MM-dd ", time);
}
function getMDHM(time) {
  return format("MM-dd hh:mm", time);
}
function getHM(time) {
  return format("hh:mm", time);
}
function bonusTypes(type) {
  if (type === "0") {
    return "前置红利";
  } else if (type === "1") {
    return "后置红利";
  } else if (type === "2") {
    return "减去红利";
  }
}
function withdrawalStatus(type) {
  let S = "";
  switch (type) {
    case "0":
      return "申请中";
    case "1":
      return "出款中";
    case "2":
      return "成功";
    case "3":
      return "拒绝";
    case "4":
      return "出款中";
  }
  return S;
}
// 存款订单状态
function depositOrderStatus(type) {
  if (type === "0") {
    return "未支付";
  } else if (type === "1") {
    return "已支付";
  } else if (type === "2") {
    return "已过期";
  }
}
function pushType(type) {
  let S = "";
  switch (type) {
    case 1:
      return "充值信息";
    case 2:
      return "维护信息";
    case 3:
      return "异常通知";
    case 4:
      return "优惠通知";
    case 5:
      return "获奖通知";
    case 6:
      return "首页公告";
    case 7:
      return "首页推荐";
    default:
  }
  return S;
}
function toMoney(money = 0) {
  return Number(money).toFixed(2);
}
function INbankNumber(num) {
  // num = num+'';
  return "**** **** **** " + num.substring(num.length - 4);
}
// ek 取款稽核
function ekwithdrawaudit(type) {
  let S = "";
  switch (type) {
    case "0":
      return "ekwithdraw.WithdrawalList.status0";
    case "1":
      return "ekwithdraw.WithdrawalList.status1";
  }
  return S;
}

// ek  取款状态
function ekwithdraw(type) {
  let S = "";
  switch (type) {
    case "0":
      return "ekfinanHistory.withdrawtable.filter.Applying"; //申请中
    case "1":
      return "ekfinanHistory.withdrawtable.filter.Pending"; //风控审核成功
    case "2":
      return "ekfinanHistory.withdrawtable.filter.Succeeded"; //财务审核成功
    case "3":
      return "ekfinanHistory.withdrawtable.filter.RiskRejected"; //拒绝
    case "4":
      return "ekfinanHistory.withdrawtable.filter.Processing"; //代付处理中
    case "5":
      return "ekfinanHistory.withdrawtable.filter.Rejectede"; //代付失败
  }
  return S;
}

// 金额格式化
function formatCurrency(num) {
  num = num.toString().replace(/\$|\,/g, "");
  if (isNaN(num)) num = "0";
  let sign = num == (num = Math.abs(num));
  num = Math.floor(num * 100 + 0.50000000001);
  let cents = num % 100;
  num = Math.floor(num / 100).toString();
  if (cents < 10) cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
    num =
      num.substring(0, num.length - (4 * i + 3)) +
      "," +
      num.substring(num.length - (4 * i + 3));
  return (sign ? "" : "-") + num + "." + cents;
}
// 投注记录状态
function gameHistoryStatus(type) {
  let S = "";
  switch (type) {
    case "0":
      return "ghistory.Running";
    case "1":
      return "ghistory.Settled";
  }
  return S;
}

// 代理佣金日期
function getTimeCommission(time) {
  return format("yyyy-MM", time);
}
// ek 投注记录状态
function ekgamehistory(type) {
  let S = "";
  switch (type) {
    case "0":
      return "ekgamehistory.tabs.Running";
    case "1":
      return "ekgamehistory.tabs.Settled";
  }
  return S;
}

export default {
  formatPhone: formatPhone,
  formatPhone2,
  toName: toName,
  bankNumber: bankNumber,
  changeName: changeName,
  changeTitle: changeTitle,
  subChangeTitle: subChangeTitle,
  getTimeMS: getTimeMS,
  getTimeMS_: getTimeMS_,
  getTimeMD: getTimeMD,
  getMDHM,
  getHM,
  bonusTypes: bonusTypes,
  bonusName: bonusName,
  gameType: gameType,
  gameType2: gameType2,
  withdrawalStatus: withdrawalStatus,
  pushType: pushType,
  toMoney: toMoney,
  jackpotUserName: jackpotUserName,
  bonusLockStatus,
  depositLockStatus,
  bonusLockPlatform,
  userName,
  slotgameType: slotgameType,
  getTimeCM,
  depositOrderStatus: depositOrderStatus,
  DCbankNumber,
  DCUsdtType,
  INbankNumber,
  moneyFilter,
  formatCurrency,
  gameHistoryStatus,
  ekwithdrawaudit,
  ekwithdraw,
  getTimeCommission,
  ekgamehistory,
};



// WEBPACK FOOTER //
// ./src/common/filter/infoFilter.js